import Vue from 'vue'
import scheduleApi from '@/api/schedule.api'

const state = {
  schedules: {},
  loadedByProject: {}
}


const getters = {
  schedulesByProject: (state) => (projectId) => {
    const list = Object.values(state.schedules) || []
    return list.filter(schedule => schedule.projectId === projectId)
  },

  schedulesByProjectLoaded: (state) => (projectId) => {
    return state.loadedByProject[projectId] === true
  },

  scheduleById: (state) => (id) => {
    return state.schedules[id] || null
  }
}


const actions = {
  async loadSchedulesByProject ({ commit, rootState }, projectId) {
    const response = await scheduleApi.getSchedules(rootState.tenant.current, projectId)
    commit('SET_SCHEDULES', { projectId, schedules: response.data })
  },

  async loadScheduleById ({ commit, rootState }, { id, projectId }) {
    const response = await scheduleApi.getSchedule(rootState.tenant.current, projectId, id)
    commit('SET_SCHEDULE', response.data)
    return response.data
  },

  // async loadScheduleByScheduleData ({ commit, rootState }, scheduleData) {
  //   const response = await scheduleApi.getSchedule(rootState.tenant.current, scheduleData.projectId, scheduleData.id)
  //   commit('SET_SCHEDULE', response.data)
  //   return response.data
  // },
  //
  // async updateScheduleByScheduleData ({ commit }, scheduleData) {
  //   commit('UPDATE_SCHEDULE', scheduleData)
  // },

  async loadAndUpdateSchedule ({ commit, rootState }, entityData) {
    const response = await scheduleApi.getSchedule(rootState.tenant.current, entityData.projectId, entityData.entityId)
    commit('UPDATE_SCHEDULE', response.data)
    return response.data
  },

  async createSchedule ({ commit, rootState }, schedule) {
    const response = await scheduleApi.createSchedule(rootState.tenant.current, schedule.projectId, schedule)
    commit('CREATE_SCHEDULE', response.data)
    return response.data
  },

  async putSchedule ({ commit, rootState }, schedule) {
    const response = await scheduleApi.putSchedule(rootState.tenant.current, schedule.projectId, schedule.id, schedule)
    commit('UPDATE_SCHEDULE', response.data)
  },

  async deleteSchedule ({ commit, rootState }, { id, projectId }) {
    await scheduleApi.deleteSchedule(rootState.tenant.current, projectId, id)
    commit('DELETE_SCHEDULE', id)
  },

  async getSchedulePdf ({ rootState }, { id, projectId }) {
    const response = await scheduleApi.getSchedulePdf(rootState.tenant.current, projectId, id)
    return response.data
  }
}


const mutations = {
  SET_SCHEDULES (state, { projectId, schedules }) {
    state.schedules = {}
    Vue.set(state.loadedByProject, projectId, true)

    for (const schedule of schedules) {
      Vue.set(state.schedules, schedule.id, schedule)
    }
  },

  SET_SCHEDULE (state, schedule) {
    Vue.set(state.schedules, schedule.id, schedule)
  },

  CREATE_SCHEDULE (state, schedule) {
    Vue.set(state.schedules, schedule.id, schedule)
  },

  UPDATE_SCHEDULE (state, schedule) {
    Vue.set(state.schedules, schedule.id, schedule)
  },

  DELETE_SCHEDULE (state, id) {
    Vue.delete(state.schedules, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
